import { css } from '@emotion/css';

export const activeAccountDialog = css`
  text-align: center;

  .MuiDialogTitle-root {
    padding: 24px !important;
  }

  .MuiDialogContent-root {
    padding: 8px 24px !important;
  }
`;

export const activeAccountContent = css`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const paymentDialogHeader = css`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: #00acf0;
  height: 19px;
`;

export const paymentDialogTxt = css`
  font-family: Nunito;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #5e5e5e;
`;

export const paymentDialogTxt1 = css`
  font-family: Nunito;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: right;
  color: #5e5e5e;
`;

export const failoverDialogHeader = css`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #5e5e5e;
`;

export const failoverDialogContent = css`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ababab;
`;

export const failoverDialogFooter = (type) => css`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: ${type === 'enabled'
    ? `#5e5e5e`
    : type === 'disabled'
    ? `#e0e0e0`
    : `#00acf0`};
  cursor: ${type !== 'disabled' ? `pointer` : `default`};
  margin-top: 10px;
  margin-bottom: 2px;
`;

export const failOverPadding = css`
  padding-top: 50px;
  padding-bottom: 50px;
`;

export const failoverAcceptedHeading = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #00acf0;
  margin-top: 10px;
`;

export const failoverAcceptedContent = css`
  opacity: 0.85;
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  color: #5e5e5e;
  margin: 0 0 16px 0;
`;

export const privyFailOverAcceptedContent = css`
  font-size: 13px;
  line-height: 1.25;
  letter-spacing: 0.2px;
  text-align: center;
  color: #5e5e5e;
  width: 100%;
`;
